import React, { useState } from "react"
import cn from "classnames"

import s from "./VideoModule.module.scss"
import { Heading, Only, Section } from "src/utils"
import { Container } from "src/layout/container/Container"
import { SanityVideo } from "../../sanity/types"
import { SanityRichText } from "src/sanity/types"
import RichText from "src/components/rich-text/RichText"
import dynamic from "next/dynamic"
import { Button } from "src/components/button/Button"
import { useSettings } from "src/layout/page/settingsContext"
import { getTranslation } from "src/lib/translations"
const Vimeo = dynamic(() => import("@u-wave/react-vimeo"))

interface VideoModuleProps {
    title?: string
    body?: SanityRichText
    video: SanityVideo
}

export default function VideoModule({ title, body, video }: VideoModuleProps): JSX.Element {
    const [isActivated, setIsActivated] = useState(video.autoplay)
    const { lang } = useSettings()
    const t = getTranslation("misc", lang)
    return (
        <Section>
            <Container>
                <div className={s["video-module"]}>
                    <Only if={title || body}>
                        <div className={s["video-module__text-container"]}>
                            <Only if={title}>
                                <Heading className={cn(s["video-module__title"], "heading-200")}>{title}</Heading>
                            </Only>
                            <Only if={body}>
                                <RichText blocks={body}  className={cn(s["video-module__body"], "paragraph-200")} />
                            </Only>
                        </div>
                    </Only>
                    <div className={s["video-module__video-container"]} style={{ aspectRatio: video.width/video.height }}>

                        {/* When not activated, we just show a simple lightweight preview of the video, without loading any code  */}
                        {!isActivated && (
                            <div className={cn(s["video-module__preview"])} onClick={() => setIsActivated(true)} style={{
                                "backgroundImage": `url(${video.thumbnail.url || `https://vumbnail.com/${video.src.split("/").slice(-1)[0]}` })`,
                            }}>
                                <Button pill appearance="secondary" className={cn(s["video-module__preview__play-icon"])} >{t.playVideo}</Button>
                            </div>
                        )}

                        {isActivated && (
                            <Vimeo
                                video={video.src}
                                autoplay={true}
                                loop={video.loop}
                                dnt={true}
                                muted={video.autoplay}
                                responsive={true}
                                autopause={true}
                                height="auto"
                                controls={video.controls}
                                className={s["video-module__video"]}
                            />
                        )}
                    </div>
                </div>
            </Container>
        </Section>
    )
}
